import { Link } from 'react-router-dom';
import { FaFacebook, FaTwitter, FaLinkedin, FaInstagram, FaWhatsapp, FaEnvelope, FaPhone, FaMapMarkerAlt } from 'react-icons/fa';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-secondary-900 text-white pt-12 pb-6">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <div className="flex justify-center mb-4">
              <img src="/logo.png" alt="Vedus Logo" className="h-12" />
            </div>
            <p className="text-secondary-300 mb-4 text-center">
              Delivering Speed Globally, Powered by Reliability. With Professionals over 30 years of expertise in global and domestic logistics.
            </p>
            <div className="flex justify-center space-x-4">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="text-secondary-400 hover:text-primary-400 transition-colors">
                <FaFacebook size={20} />
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="text-secondary-400 hover:text-primary-400 transition-colors">
                <FaTwitter size={20} />
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="text-secondary-400 hover:text-primary-400 transition-colors">
                <FaLinkedin size={20} />
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="text-secondary-400 hover:text-primary-400 transition-colors">
                <FaInstagram size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-white">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-secondary-300 hover:text-primary-400 transition-colors">Home</Link>
              </li>
              <li>
                <Link to="/about" className="text-secondary-300 hover:text-primary-400 transition-colors">About Us</Link>
              </li>
              <li>
                <Link to="/services" className="text-secondary-300 hover:text-primary-400 transition-colors">Services</Link>
              </li>
              <li>
                <Link to="/quote" className="text-secondary-300 hover:text-primary-400 transition-colors">Request Quote</Link>
              </li>
              <li>
                <Link to="/contact" className="text-secondary-300 hover:text-primary-400 transition-colors">Contact</Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-white">Our Services</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/services#road" className="text-secondary-300 hover:text-primary-400 transition-colors">Road Transport</Link>
              </li>
              <li>
                <Link to="/services#air" className="text-secondary-300 hover:text-primary-400 transition-colors">Air Freight</Link>
              </li>
              <li>
                <Link to="/services#train" className="text-secondary-300 hover:text-primary-400 transition-colors">Rail Transport</Link>
              </li>
              <li>
                <Link to="/services#ship" className="text-secondary-300 hover:text-primary-400 transition-colors">Sea Freight</Link>
              </li>
              <li>
                <Link to="/services#domestic" className="text-secondary-300 hover:text-primary-400 transition-colors">Domestic Shipping</Link>
              </li>
              <li>
                <Link to="/services#international" className="text-secondary-300 hover:text-primary-400 transition-colors">International Shipping</Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-white">Contact Us</h3>
            <ul className="space-y-3">
              <li className="flex items-start">
                <FaMapMarkerAlt className="text-primary-400 mt-1 mr-3" />
                <span className="text-secondary-300">Plot No-2, Bhurarani Road, City One, Rudrapur, U.S Nagar Uttarakhand, 263153</span>
              </li>
              <li className="flex items-center">
                <FaPhone className="text-primary-400 mr-3" />
                <a href="tel:+919411305200" className="text-secondary-300 hover:text-primary-400 transition-colors">+91 94113 05200</a>
              </li>
              <li className="flex items-center">
                <FaEnvelope className="text-primary-400 mr-3" />
                <a href="mailto:Vedusscm@gmail.com" className="text-secondary-300 hover:text-primary-400 transition-colors">Vedusscm@gmail.com</a>
              </li>
              <li className="flex items-center">
                <FaWhatsapp className="text-primary-400 mr-3" />
                <a href="https://wa.me/919411305200" className="text-secondary-300 hover:text-primary-400 transition-colors">WhatsApp Support</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-secondary-800 mt-8 pt-6">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-secondary-400 text-sm">
              &copy; {currentYear} VEDUS Supply Chain Management Pvt. Ltd. All rights reserved.
            </p>
            <div className="mt-4 md:mt-0">
              <ul className="flex space-x-4 text-sm text-secondary-400">
                <li>
                  <Link to="/privacy-policy" className="hover:text-primary-400 transition-colors">Privacy Policy</Link>
                </li>
                <li>
                  <Link to="/terms-of-service" className="hover:text-primary-400 transition-colors">Terms of Service</Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;